module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.b8d92071.mp3";